import {
  CrosshairIcon,
  PanHorizontalIcon,
  ZoomToSelectionIcon,
} from '@dynatrace/strato-icons';

import {
  INTERACTION_MODE,
  type InteractionMode,
} from '../../interactions-overlay/types.js';

export const getMenuTriggerIcon = (
  interactionMode: InteractionMode,
  isZoomEnabled: boolean | undefined,
) => {
  switch (interactionMode) {
    case INTERACTION_MODE.Pan:
      return <PanHorizontalIcon />;
    case INTERACTION_MODE.Zoom:
      return isZoomEnabled ? <ZoomToSelectionIcon /> : <CrosshairIcon />;
    default:
      return <CrosshairIcon />;
  }
};
